var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmsMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 3,
  height: 12,
  viewBox: "0 0 3 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M1.2 9.6a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4m0-4.8a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4m0-4.8a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4"
})));
export default SvgSmsMore;